import Tasks from 'APP/Tasks';
import { IPinSpaceResponse } from 'APP/model/space/spaceModel.types';

import { GroupsEvent } from '../GroupsEvent';

interface ISpacesPinChangedEventData {
  pinOrders: {
    spaceId: string;
    pinOrder: string;
  }[];
}

const mapSpacePinOrderResponse = (data: ISpacesPinChangedEventData): IPinSpaceResponse[] => {
  return data.pinOrders.map((item) => ({
    spaceId: item.spaceId,
    pinOrder: parseInt(item.pinOrder, 10),
  }));
};

export class SpacesPinChanged extends GroupsEvent<ISpacesPinChangedEventData> {
  process(): void {
    if (!this.eventPayload) {
      return;
    }

    Tasks.space.updateSpacesPinOrder(mapSpacePinOrderResponse(this.eventPayload));
  }
}
